import styled from '@emotion/styled';

export const EmptyPlayersMessageContainer = styled.div`
  font-family: 'SF Pro Display', sans-serif;
  color: #8f8e99;
  text-align: center;
`;
